module.exports = __webpack_public_path__ + "static/img/top.5a1b582.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/top.png
// module id = djPG
// module chunks = 24